var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoVtBlueMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 144,
    viewBox: "0 0 250 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0065 98.7451L0 143.624H6.95392L28.9604 98.7451H22.0065Z",
    fill: "#0E0E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3807 44.8785L60.9656 98.7327H67.9073L94.3224 44.8785H87.3807Z",
    fill: "#0E0E2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3754 44.8785L77.382 0H70.4402L48.4215 44.8785H55.3754Z",
    fill: "#0E0E2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8515 98.7451L77.8328 143.624H84.7867L106.793 98.7451H99.8515Z",
    fill: "#0E0E2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.213 44.8785L138.798 98.7327H145.752L172.167 44.8785H165.213Z",
    fill: "#0E0E2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.208 44.8785L155.227 0H148.273L126.266 44.8785H133.208Z",
    fill: "#0E0E2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.684 98.7451L155.678 143.624H162.619L184.638 98.7451H177.684Z",
    fill: "#0E0E2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.058 44.8785L216.631 98.7327H223.585L250 44.8785H243.058Z",
    fill: "#0E0E2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.053 44.8785L233.06 0H226.118L204.099 44.8785H211.053Z",
    fill: "#0E0E2C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6911 91.1101C28.2542 91.1101 19.7657 82.4448 19.7657 71.8056C19.7657 61.1663 28.2542 52.501 38.6911 52.501C49.1281 52.501 57.6287 61.1663 57.6287 71.8056C57.6287 82.4448 49.1281 91.1101 38.6911 91.1101Z",
    fill: "#208AC6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.536 91.1101C106.099 91.1101 97.5986 82.4448 97.5986 71.8056C97.5986 61.1663 106.087 52.501 116.536 52.501C126.985 52.501 135.474 61.1663 135.474 71.8056C135.474 82.4448 126.985 91.1101 116.536 91.1101Z",
    fill: "#208AC6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.369 91.1101C183.932 91.1101 175.431 82.4448 175.431 71.8056C175.431 61.1663 183.92 52.501 194.369 52.501C204.818 52.501 213.294 61.1663 213.294 71.8056C213.294 82.4572 204.806 91.1101 194.369 91.1101Z",
    fill: "#208AC6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoVtBlueMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-VT-blue-mobile.687792c7a040da0a863d7964500b00a0.svg";